import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import Loading from '../pages/Loading/Loading';

const NotFound = lazy(() => import('../pages/NotFound/NotFound'));

export const Route = createFileRoute('/$')({
  component: () => (
    <Suspense fallback={<Loading />}>
      <NotFound />
    </Suspense>
  ),
});
